// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"419abf6a","553":"ba2d1a00","952":"fe4dd16f","977":"5b55637c"}[chunkId] + ".chunk.js";
};